import React from 'react';

export default function Privacidade() {
  return (
    <div className="results-page">
      <div className="container results-container" style={{ maxWidth: 760 }}>
        <h2 style={{ marginBottom: 16 }}>Termo de Privacidade de Dados</h2>
        <p style={{ color: 'var(--texto-secundario)', marginBottom: 20, lineHeight: 1.7 }}>
          Última atualização: outubro de 2026
        </p>

        <div style={{ lineHeight: 1.8, fontSize: 14 }}>
          <h3 style={{ marginBottom: 8 }}>1. Quais dados são tratados</h3>
          <p style={{ marginBottom: 16 }}>
            O Memorial Parque Dourados utiliza dados de sepultados (nome, datas de nascimento e falecimento,
            número do jazigo, quadra e setor) exclusivamente para viabilizar o serviço público de
            localização de jazigos oferecido neste site. Não comercializamos esses dados.
          </p>

          <h3 style={{ marginBottom: 8 }}>2. Finalidade</h3>
          <p style={{ marginBottom: 16 }}>
            Os dados exibidos na busca têm finalidade exclusivamente informativa e de utilidade pública,
            permitindo que familiares e visitantes encontrem o local de sepultamento.
          </p>

          <h3 style={{ marginBottom: 8 }}>3. Seus direitos</h3>
          <p style={{ marginBottom: 16 }}>
            Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018), você pode solicitar a
            <strong> remoção de um registro da busca pública</strong>. Após o pedido, o registro deixa de
            aparecer nos resultados de busca deste site.
          </p>

          <h3 style={{ marginBottom: 8 }}>4. Como solicitar a remoção</h3>
          <p style={{ marginBottom: 12 }}>
            Envie um e-mail para <strong>privacidade@cemiterioparquededourados.com.br</strong> com o assunto
            <em> “Solicitação de remoção de dados”</em>, informando:
          </p>
          <ul style={{ marginBottom: 16, paddingLeft: 24 }}>
            <li style={{ marginBottom: 6 }}>Nome completo da pessoa cujo registro deve ser removido;</li>
            <li style={{ marginBottom: 6 }}>Número do jazigo, quadra e setor (se conhecidos);</li>
            <li style={{ marginBottom: 6 }}>Nome e contato do solicitante e vínculo com a pessoa (familiar, responsável etc.);</li>
            <li>Uma cópia de documento que comprove o vínculo, quando solicitado.</li>
          </ul>
          <p style={{ marginBottom: 16 }}>
            O atendimento será realizado no prazo razoável previsto na LGPD, com confirmação por e-mail
            quando a remoção for concluída.
          </p>

          <h3 style={{ marginBottom: 8 }}>5. Contato</h3>
          <p style={{ marginBottom: 16 }}>
            Dúvidas sobre este termo ou sobre o tratamento de dados podem ser encaminhadas para o mesmo
            endereço: <strong>privacidade@cemiterioparquededourados.com.br</strong>.
          </p>
        </div>
      </div>
    </div>
  );
}
